<template>
    <MiscDefineLink :to="computedTo" :target="target">
        <slot />
    </MiscDefineLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLocalisation, useRoute } from '#imports'

const props = defineProps({
    to: {
        type: String,
        required: true
    },
    target: {
        type: String,
        required: false,
        default: null
    }
})

const route = useRoute()
const { isLocalisedRoute } = useLocalisation()
const routeLocale = isLocalisedRoute(route.path)

const computedTo = computed(() => {
    if (routeLocale) {
        let path = props.to

        if (typeof path === 'string' && path.startsWith('/')) {
            path = path.substring(1)
        }

        return `/${routeLocale}${path === '' ? '' : '/'}${path}`
    }

    return props.to
})
</script>
